export default "__VITE_ASSET__5ef56e57__"